/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://f4jflnpejjdqpjqnjwoinkox7y.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-xvvmfuorwvb5pkhzgnapc4qqym",
    "aws_cloud_logic_custom": [
        {
            "name": "nextlevel757AI",
            "endpoint": "https://idj78dgw69.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "757nextlevelwebassets23820-staging",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:29d88d74-e8ad-4658-b866-d4b6bb4ad238",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_gR5youvqf",
    "aws_user_pools_web_client_id": "531o7tngdbdhvc1o5fbmovik71",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_mobile_analytics_app_id": "a09d3947497644acbb53b242b0e0dcf5",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
